import 'globals';

(function (PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        new LazyEmbed({
            elements: '[data-lazyembed="video"]',
            overlayText: _AVENCY_BASE_translations.dsgvoCompliance.privacyPolicyHint.video.replace('{uri}', _AVENCY_BASE_pages.privacyPolicy)
        });
        new LazyEmbed({
            elements: '[data-lazyembed="map"]',
            overlayText: _AVENCY_BASE_translations.dsgvoCompliance.privacyPolicyHint.map.replace('{uri}', _AVENCY_BASE_pages.privacyPolicy)
        });
    });
})(window.PageLoadedQueue);
